export class ChangeTitle {
  public static readonly type = "[Settings] Change Title";

  public constructor(public title: string) {}
}
